import { type MutableRefObject, type Ref } from 'react';

// assign multiple refs to the same DOM node
const assignRefs =
  <T>(...refs: Ref<T | null>[]) =>
  (node: T | null) => {
    refs.forEach(r => {
      if (typeof r === 'function') {
        r(node);
      } else if (r) {
        (r as MutableRefObject<T | null>).current = node;
      }
    });
  };

export default assignRefs;
